import {cva, type VariantProps} from "class-variance-authority";

export {default as Dialog} from './Dialog.vue'
export {default as DialogClose} from './DialogClose.vue'
export {default as DialogTrigger} from './DialogTrigger.vue'
export {default as DialogHeader} from './DialogHeader.vue'
export {default as DialogTitle} from './DialogTitle.vue'
export {default as DialogDescription} from './DialogDescription.vue'
export {default as DialogContent} from './DialogContent.vue'
export {default as DialogScrollContent} from './DialogScrollContent.vue'
export {default as DialogFooter} from './DialogFooter.vue'


export const dialogContentVariant = cva(
    '',
    {
        variants: {
            overlay: {
                default: 'bg-black/80',
                half: '!bg-[rgba(0,0,0,0.5)]',
                black: 'bg-black',
                blurred: '!bg-[rgba(0,0,0,0.6)] backdrop-blur-xl'
            },
            content: {
                default: 'bg-background border',
                transparent: 'bg-transparent'
            },
        }
    },
)

export type DialogContentVariants = VariantProps<typeof dialogContentVariant>